import useSearchConfiguration from "hooks/useSearchConfiguration";
import { durationInSeconds } from "util/DateTime";
import { DEFAULT_TIME_RANGE_SECONDS } from "./useWelcomeSearch";
const useMetricsTimeRange = () => {
  var _a;
  const { config } = useSearchConfiguration();
  const queryTimeRangeLimitSeconds = durationInSeconds((_a = config == null ? void 0 : config.query_time_range_limit) != null ? _a : "");
  return queryTimeRangeLimitSeconds > 0 && queryTimeRangeLimitSeconds < DEFAULT_TIME_RANGE_SECONDS ? queryTimeRangeLimitSeconds : DEFAULT_TIME_RANGE_SECONDS;
};
export default useMetricsTimeRange;
